import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  bgColor15,
  blackShade05,
  blackShade159,
  blackShade19,
  greenStatusColor01,
  greyColor060,
  greyColor10,
  greyColor24,
  greyColor42,
  lightgreenColor04,
  lightOrange04,
  logoImgborder,
  logoImgborder1,
  orangeColor03,
  orderCardBorder,
  redColor09,
  redStatusColor01,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import {
  addThousandsSeparator,
  getDiscountPercentage,
} from "../../../utils/helper";
import { getViewChildProductDetailsAPI } from "../../../service/api_calls/catalog/CatalogAPI";
import ThreeDotLoader from "../../../components/ThreeDotLoader";

function ChildVariantCardPopup({ mainVariant }) {
  const [loading, setLoading] = useState(false);
  const [childVariantsData, setChildVariantsData] = useState([]);

  const getCartData = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    setLoading(true);
    let childVariants = [];
    if (mainVariant?.variantInfo?.masterProductVariantId) {
      childVariants = await getViewChildProductDetailsAPI(
        mainVariant?.variantInfo?.masterProductVariantId,
        businessId
      );

      if (childVariants) {
        setChildVariantsData(childVariants?.details || []);
        setLoading(false);
        return;
      }
    }

    setLoading(false);
  };

  //     const childVariantsData = prepareViewChildVariantProductData({
  //       childVariants: childVariants?.details,
  //       specification,
  //       fullSpecification,
  //       selectedVariant: mainProductData?.selectedVariant,
  //       sVariants: productDetails?.variantInfo?.variants,
  //       unitOfMeasurementData: [],
  //     });
  useEffect(() => {
    if (mainVariant) getCartData();
    return () => {};
  }, []);
  console.log("childVariants", childVariantsData);

  return (
    <Box sx={styles.container}>
      <Typography
        variant="h5"
        fontSize={17}
        fontWeight={600}
        color={blackShade05}
      >
        Variant Product Detail
      </Typography>
      <Box sx={styles.cardHeading} mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={5}>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={400}
              color={greyColor060}
            >
              Product Info
            </Typography>
          </Grid>
          <Grid item xs={6} md={2}>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={400}
              color={greyColor060}
            >
              Category & Sub Category
            </Typography>
          </Grid>{" "}
          <Grid item xs={6} md={1}>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={400}
              color={greyColor060}
            >
              Availability
            </Typography>
          </Grid>
          <Grid item xs={6} md={1.2}>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={400}
              color={greyColor060}
            >
              Available QTY
            </Typography>
          </Grid>
          <Grid item xs={6} md={1.8}>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={400}
              color={greyColor060}
            >
              Price
            </Typography>
          </Grid>
          <Grid item xs={12} md={1}>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={400}
              color={greyColor060}
            >
              Sold QTY
            </Typography>
          </Grid>
        </Grid>
      </Box>
      {loading ? <> <ThreeDotLoader /></>:childVariantsData?.map((item, index) => (
        <Box sx={styles.card}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={6} md={5}>
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <Box
                  component="img"
                  alt="Product Image"
                  src={item?.productPhoto?.[0]?.docURL}
                  width="40px"
                  height="40px"
                  sx={{
                    objectFit: "contain",
                    border: logoImgborder1,
                    borderRadius: "7px",
                    // padding: "3px",
                  }}
                />
                {/* <Box
                    sx={{
                      position: "relative",
                      width: "40px",
                      height: "40px",
                      padding: "3px",
                      backgroundColor: "#ffffff",
                      alignItems: "center",
                      textAlign: "center",
                      borderRadius: "5px",
                      border: "1px solid #e5e9f0",
                      marginRight: "12px",
                      display: "flex",
                      justifyContent: "space-around",
                    }}
                  >
                    <Box
                      component="img"
                      maxHeight={{ xs: "29px", md: "40px" }}
                      src={item?.productPhoto?.[0]?.docURL}
                      alt="CostBo"
                    />
                  </Box> */}
                <Typography
                  variant="h3"
                  fontSize={{ xs: 12, md: 12 }}
                  color={blackShade19}
                  fontWeight={600}
                  lineHeight={1.5}
                >
                  {item?.productName}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography variant="h5" sx={styles.mainText}>
                {item?.productMainCategory?.[0]?.ondcValue}
              </Typography>
              <Typography
                variant="h5"
                fontSize={11}
                fontWeight={400}
                color={bgColor15}
              >
                {item?.productSubCategory?.[0]?.ondcSubValue}
              </Typography>
            </Grid>{" "}
            <Grid item xs={6} md={1}>
              <Box
                sx={{
                  fontWeight: 500,
                  fontSize: "12px",
                  color:
                    item.availability?.[0] == "Yes"
                      ? greenStatusColor01
                      : redStatusColor01,
                  textAlign: "center",
                  backgroundColor:
                    item.availability?.[0] == "Yes"
                      ? lightgreenColor04
                      : redColor09,
                  // padding: "2px 4px",
                  width: "40px",
                  borderRadius: "4px",
                }}
              >
                {item.availability?.[0] == "Yes" ? "Yes" : "No"}
              </Box>
            </Grid>
            <Grid item xs={6} md={1.2}>
              <Typography variant="h5" sx={styles.mainText}>
                {item?.availableQuantity}
              </Typography>
            </Grid>
            <Grid item xs={12} md={1.8}>
              <Box display={"flex"} gap={1}>
                {item?.productOriginalPrice !== item?.productSalePrice && (
                  <Typography
                    variant="h1"
                    fontSize={12}
                    fontWeight={500}
                    color={bgColor15}
                    sx={{ textDecoration: "line-through" }}
                  >
                    ₹ {addThousandsSeparator(item?.productOriginalPrice)}
                  </Typography>
                )}

                <Typography variant="h5"  sx={styles.mainText}>
                  ₹ {addThousandsSeparator(item?.productSalePrice)}
                </Typography>
                <Typography
                  variant="h5"
                  fontSize={12}
                  fontWeight={600}
                  color={greenStatusColor01}
                >
                  {item?.productOriginalPrice !== item?.productSalePrice
                    ? `${getDiscountPercentage(
                        item?.productSalePrice,
                        item?.productOriginalPrice
                      )}%`
                    : ""}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={1}>
              <Box
                sx={{
                  fontWeight: 500,
                  fontSize: "12px",
                  color: orangeColor03,
                  textAlign: "center",
                  backgroundColor: lightOrange04,
                  // padding: "2px 4px",
                  width: "40px",
                  borderRadius: "4px",
                }}
              >
                {item?.soldQuantity ? item?.soldQuantity : "-"}
              </Box>
            </Grid>
          </Grid>
          {/* {JSON.stringify(item?.productinfo)} */}
        </Box>
      ))}
    </Box>
  );
}

export default ChildVariantCardPopup;

const styles = {
  container: {
    backgroundColor: whiteColor,
    borderRadius: "12px",
    padding: "20px",

    maxHeight: { md: "95vh", xs: "70vh" },
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "4px",
      // height: "1px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: blackShade159,
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "50px !important",
    },
  },
  cardHeading: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    // backgroundColor: whiteColor,
    backgroundColor: greyColor42,
    border: orderCardBorder,
    borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    position: "sticky",
    top: 0,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    // borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    // position: "sticky",
    // top: 248,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  actionBtn: {
    fontSize: "13px",
    fontWeight: "600",
    color: greyColor24,
    backgroundColor: whiteColor,
    padding: "4px 22px",
    my: "10px",
    border: `1px solid ${greyColor24}`,
    "&:hover": {
      color: whiteColor,
      backgroundColor: greyColor24,
    },
  },
  statsCard: {
    width: { xs: "100%", md: "40%" },
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "center",
    gap: { xs: "20px", md: "35px" },
    backgroundColor: whiteColor,
    padding: { xs: "10px 16px", md: "8px 16px" },
    borderRadius: { xs: "8px", md: "12px" },
    border: `1px solid ${greyColor10}`,
    m: { xs: "12px 0 12px 0", md: "0" },
  },
  mobileTabs: {
    width: { xs: "90vw", md: "calc(100% - 100px)" },
    display: "flex",
    alignItems: "center",
    textTransform: "capitalize",
    mb: 1,
    borderBottom: logoImgborder,
  },
  mainText: {
    fontSize: "12px",
    color: blackShade19,
    fontWeight: 600,
    lineHeight: "16px",
    marginBottom: "0px",
    marginTop: "0px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
};
